import { render, staticRenderFns } from "./sale-returns.vue?vue&type=template&id=580e3564&scoped=true"
import script from "./sale-returns.vue?vue&type=script&lang=js"
export * from "./sale-returns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580e3564",
  null
  
)

export default component.exports